/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compare_WithInputs */

const en_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Alchema`)
};

const de_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Alchema`)
};

const fr_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec Alchema`)
};

const es_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Alchema`)
};

const it_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Alchema`)
};

const nl_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met Alchema`)
};

const pl_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z Alchema`)
};

const fi_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcheman kanssa`)
};

const da_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Med Alchema`)
};

const sv_landing_compare_with = /** @type {(inputs: Landing_Compare_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Med Alchema`)
};

/**
* | output |
* | --- |
* | "With Alchema" |
*
* @param {Landing_Compare_WithInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compare_with = /** @type {((inputs?: Landing_Compare_WithInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compare_WithInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compare_with(inputs)
	if (locale === "fr") return fr_landing_compare_with(inputs)
	if (locale === "es") return es_landing_compare_with(inputs)
	if (locale === "it") return it_landing_compare_with(inputs)
	if (locale === "nl") return nl_landing_compare_with(inputs)
	if (locale === "pl") return pl_landing_compare_with(inputs)
	if (locale === "fi") return fi_landing_compare_with(inputs)
	if (locale === "da") return da_landing_compare_with(inputs)
	if (locale === "sv") return sv_landing_compare_with(inputs)
	return en_landing_compare_with(inputs)
});